// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../types/schema';

import { AssetIntegration_EntityFragment } from '../../assetProviderIntegrations/shared/graphql/assetProviderIntegration.fragments.generated';
import { gql } from '@apollo/client';
import { AssetIntegration_EntityFragmentDoc } from '../../assetProviderIntegrations/shared/graphql/assetProviderIntegration.fragments.generated';
export type EntityListFragment = (
  { __typename?: 'Entity', id: string, kind: Types.EntityKind, stage: Types.EntityStage, integrationEntities?: Array<{ __typename?: 'IntegrationEntity', id: string, externalKind?: Types.IntegrationEntityExternalKind | null }> | null, hypotheticalGrats?: Array<{ __typename?: 'HypotheticalGRAT', id: string, hypotheticalWaterfall: { __typename?: 'EstateWaterfall', id: string } }> | null, subtype: { __typename?: 'CCorpBusinessEntity', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, displayName: string } | { __typename?: 'CLTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, remainderBeneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, lifetimeBeneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'CRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, remainderBeneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, lifetimeBeneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'CustodialPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'DonorAdvisedFund', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'GPBusinessEntity', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, displayName: string } | { __typename?: 'GRATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, assetSummaryDisplay?: string | null, termEndDate?: Time | null, currentValue: CurrencyUSD, effectiveDate?: Time | null, distributionDate?: Time | null, mostRecentValuationDate?: Time | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, distributionAssetValuation?: { __typename?: 'AssetValuationV2', id: string, valuationValue?: CurrencyUSD | null } | null } | { __typename?: 'ILITTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'IndividualPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'InsurancePersonalAccount', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, currentValue: CurrencyUSD, gstStatus?: Types.EntityGstStatus | null, inEstateStatus: Types.EntityInEstateStatus, displayName: string, policies?: Array<{ __typename?: 'InsurancePolicy', id: string }> | null } | { __typename?: 'IrrevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'JointPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'LLCBusinessEntity', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, displayName: string } | { __typename?: 'LPBusinessEntity', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, displayName: string } | { __typename?: 'PrivateFoundation', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'QPRTTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, termEndDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'QualifiedTuitionPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'RetirementPersonalAccount', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'RevocableTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, beneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'SCorpBusinessEntity', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, displayName: string } | { __typename?: 'SLATTrust', id: string, inEstateStatus: Types.EntityInEstateStatus, gstStatus?: Types.EntityGstStatus | null, currentValue: CurrencyUSD, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, displayName: string, remainderBeneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null, lifetimeBeneficiaries?: Array<{ __typename?: 'Beneficiary', id: string, summary: { __typename?: 'SummaryBeneficiaryv2', id: string, displayName: string } }> | null } | { __typename?: 'SoleProprietorshipBusinessEntity', id: string, mostRecentValuationDate?: Time | null, effectiveDate?: Time | null, assetSummaryDisplay?: string | null, grantorControlledValue: CurrencyUSD, displayName: string } }
  & AssetIntegration_EntityFragment
);

export const Operations = {
  Fragment: {
    EntityList: 'EntityList' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const EntityListFragmentDoc = gql`
    fragment EntityList on Entity {
  id
  kind
  stage
  ...AssetIntegration_Entity
  integrationEntities {
    id
    externalKind
  }
  hypotheticalGrats {
    id
    hypotheticalWaterfall {
      id
    }
  }
  subtype {
    id
    displayName
    ... on GRATTrust {
      id
      inEstateStatus
      gstStatus
      assetSummaryDisplay
      termEndDate
      currentValue
      effectiveDate
      distributionDate
      mostRecentValuationDate
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      distributionAssetValuation {
        id
        valuationValue
      }
    }
    ... on ILITTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on RevocableTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on SLATTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      remainderBeneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      lifetimeBeneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on IrrevocableTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on QPRTTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      termEndDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on IndividualPersonalAccount {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on JointPersonalAccount {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on RetirementPersonalAccount {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on CustodialPersonalAccount {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on QualifiedTuitionPersonalAccount {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on CRTTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      remainderBeneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      lifetimeBeneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on CLTTrust {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      remainderBeneficiaries {
        id
        summary {
          id
          displayName
        }
      }
      lifetimeBeneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on DonorAdvisedFund {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on PrivateFoundation {
      id
      inEstateStatus
      gstStatus
      currentValue
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      beneficiaries {
        id
        summary {
          id
          displayName
        }
      }
    }
    ... on BusinessEntity {
      id
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      grantorControlledValue
    }
    ... on InsurancePersonalAccount {
      id
      mostRecentValuationDate
      effectiveDate
      assetSummaryDisplay
      currentValue
      policies {
        id
      }
      gstStatus
      inEstateStatus
    }
  }
}
    ${AssetIntegration_EntityFragmentDoc}`;